import { makeRequest } from 'utils/requestLogger';
// import store from 'store';

export default (roundtable_id) =>
  makeRequest(
    'post',
    `/api/roundtables/${roundtable_id}/keywordGenerationForOlderRoundtables`
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/keywordGenerationForOlderRoundtables.js